import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'

import { useGetWatchLocation } from '../../hooks/useGetWatchLocation'
import styles from './replay-button.css'
import { DeepLink } from '../../hoc/deep-link'
import ConfirmationModal from '../shared/confirmation-modal'
import { KIDS_PROFILE_ADD_SUBSCRIPTION_ERROR_MESSAGE, KIDS_PROFILE_PURCHASE_ERROR_MESSAGE } from '../../constants'
import replayIcon from '../../../images/new-replay.svg'
import Button from '../button'

function ReplayButton({
  onClick,
  clickable,
  watchUrl,
  skipIntro,
  isRental,
  isKid,
  watchable,
  progressPercentage
}) {
  const [showErrorMessage, setShowErrorMessage] = useState(false)
  const watchLocation = useGetWatchLocation(watchUrl, skipIntro, isKid, watchable, true)

  /*
  * Display the Replay button only if the user was watching an episode or movie
  * but did not finish it (progressPercentage is greater than 0).
  */
  if (progressPercentage === 0) return null

  const handleOnClick = (event) => {
    if (isKid && !watchable) {
      setShowErrorMessage(true)
    }
    // Pass event into onClick to handle the event.preventDefault() for chromecast
    onClick(event)
  }

  const onConfirmClick = () => {
    setShowErrorMessage(false)
  }

  if (showErrorMessage) {
    return (
      <ConfirmationModal
        header="Hmmm"
        message={isRental ? KIDS_PROFILE_PURCHASE_ERROR_MESSAGE : KIDS_PROFILE_ADD_SUBSCRIPTION_ERROR_MESSAGE}
        confirmText="OK"
        onConfirmClick={onConfirmClick}
        customWrapperClass={styles.errorMessageWrapper}
      />
    )
  }

  return (
    <div
      className={styles.buttonContainer}
    >
      <DeepLink
        to={watchLocation}
        isPlayButton
        onClick={handleOnClick}
        className={styles.replayButtonFrame}
      >
        <Button
          className={styles.replayButton}
          isRental={isRental}
          disabled={!clickable}
          e2eIdentifier="from-start-button-on-cta-box"
          darkBGSecondary
        >
          <ReactSVG
            src={replayIcon}
            beforeInjection={(svg) => {
              svg.setAttribute('class', styles.replayIcon)
            }}
          />
        </Button>
      </DeepLink>

      <span className={styles.cta}>
        From Start
      </span>
    </div>
  )
}

ReplayButton.propTypes = {
  watchUrl: PropTypes.oneOfType([
    PropTypes.oneOfType([PropTypes.object]),
    PropTypes.string
  ]),
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
  skipIntro: PropTypes.bool,
  isRental: PropTypes.bool,
  isKid: PropTypes.bool,
  watchable: PropTypes.bool,
  progressPercentage: PropTypes.number
}

ReplayButton.defaultProps = {
  clickable: true,
  onClick: () => { },
  watchUrl: '#',
  skipIntro: false,
  isRental: false,
  isKid: false,
  watchable: false,
  progressPercentage: 0
}

export default ReplayButton
